var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6243 11.0149C11.6243 12.567 11.6243 14.0439 11.6243 15.5209C11.2676 15.5835 10.9109 15.621 10.5797 15.7087C8.61789 16.2344 7.35674 18.1244 7.66247 20.077C7.98095 22.0922 9.66247 23.4816 11.7262 23.4315C13.9427 23.3814 15.6497 21.6541 15.6497 19.4136C15.6625 15.4083 15.6497 11.4154 15.6497 7.41005C15.6497 5.03187 15.6497 2.6662 15.6497 0.288012C15.6497 0.200395 15.6497 0.100261 15.6497 -0.0123901C17.1911 -0.0123901 18.7198 -0.0123901 20.2612 -0.0123901C20.2994 1.26432 20.758 2.3658 21.6752 3.267C22.5924 4.15569 23.7134 4.59378 25.0001 4.63133C25.0001 6.14586 25.0001 7.62284 25.0001 9.1624C23.3185 9.17492 21.7771 8.72431 20.2612 7.89821C20.2612 8.06092 20.2612 8.16106 20.2612 8.27371C20.2612 11.9662 20.2612 15.6461 20.2612 19.3385C20.2612 22.3426 19.0255 24.7583 16.516 26.4731C11.2676 30.0779 3.90451 26.8736 3.07649 20.6403C2.45228 15.9465 5.77712 11.7033 10.5797 11.09C10.9109 11.0524 11.2548 11.0399 11.6243 11.0149Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 28,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.811211491948f2942e3fed66f39ef02e.svg";
export { ForwardRef as ReactComponent };